const { regionToTagMap, defaultRegion } = require("../config/i18n")

exports.regionToTag = (region) => {
  const tag = regionToTagMap[region]

  if (!tag) throw new Error("Unsupported region specified")

  return tag
}

exports.tagToRegion = (tag) => {
  const region = Object.entries(regionToTagMap).find(([, v]) => v === tag)

  if (!region) throw new Error("Unsupported IETF language tag specified")

  return region[0]
}

// We use this because useRouter doesn't always resolve the defaultLocale value from the config
exports.getDefaultRegion = () => defaultRegion

exports.getDefaultTag = () => regionToTagMap[defaultRegion]

exports.getRegions = () => Object.keys(regionToTagMap)

exports.getTags = () => Object.values(regionToTagMap)
